const API = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API}/api/ai-receptionist`;

export const air = async (path, token, body = {}) => {
  const r = await fetch(`${BASE}/${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, ...body }) });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof d.detail === "string" ? d.detail : "Request failed");
  return d;
};

export const airBlob = async (path, token, body = {}) => {
  const r = await fetch(`${BASE}/${path}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ token, ...body }) });
  if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Request failed");
  return r.blob();
};

export const airTranscribe = async (token, blob) => {
  const fd = new FormData();
  fd.append("token", token);
  fd.append("audio", blob, "speech.webm");
  const r = await fetch(`${BASE}/voice/transcribe`, { method: "POST", body: fd });
  const d = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(d.detail || "Could not understand the audio");
  return d.text;
};

export const download = (blob, name) => {
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = name;
  a.click();
};

export const backendUrl = API;

export const STATUS_CLS = {
  NOT_CONFIGURED: "bg-slate-100 text-slate-600", READY_FOR_TEST: "bg-amber-100 text-amber-800", ACTIVE: "bg-emerald-100 text-emerald-800",
  PAUSED: "bg-sky-100 text-sky-800", ERROR: "bg-red-100 text-red-800",
};
export const FOLLOW_CLS = {
  NEW: "bg-blue-100 text-blue-800", IN_PROGRESS: "bg-amber-100 text-amber-800", CALLBACK_REQUESTED: "bg-red-100 text-red-800",
  CONVERTED: "bg-emerald-100 text-emerald-800", RESOLVED: "bg-slate-100 text-slate-600",
};
export const LANGS = { en: "English", hi: "Hindi", mr: "Marathi" };
export const dur = (s) => (s ? `${Math.floor(s / 60)}m ${s % 60}s` : "—");
export const when = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
